import { IconFunctionalSuccessCircle16, Image, PromoModal, UIText1, useDeviceType } from '@cian/ui-kit';
import { FC } from 'react';
import styles from './styles.css';
import AgentsImg from './assets/img_agents 1.png';
import { QUALITY_CRITERIA_LIST, QUALITY_CRITERIA_MODAL_TITLE } from './constants';
import { clsx } from 'clsx';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

interface IQualityCriteriaModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const QualityCriteriaModal: FC<IQualityCriteriaModalProps> = ({ isOpen, handleClose }) => {
  const device = useDeviceType();

  const description = (
    <div className={clsx(styles['quality-criteria_content'], styles[device])}>
      <div className={styles['quality-criteria_list']}>
        {QUALITY_CRITERIA_LIST.map((criteria, index) => (
          <div key={index} className={styles['quality-criteria_item']}>
            <div className={styles['quality-criteria_icon']}>
              <IconFunctionalSuccessCircle16 color="icon-positive-default" width={16} height={16} />
            </div>
            <UIText1>{criteria}</UIText1>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <PromoModal
      open={isOpen}
      onOpenChange={handleClose}
      title={QUALITY_CRITERIA_MODAL_TITLE}
      closeButtonProps={{ theme: 'fill_light', title: 'Закрыть', icon: <IconActionClose16 /> }}
      // @ts-expect-error Модалка умеет обрабатывать JSX
      description={description}
      media={<Image src={AgentsImg} />}
      actionText="Круто!"
      onPrimaryAction={handleClose}
    />
  );
};
